import { type MotdPosition, type PositionPlaceholder } from "./models";

import { ref } from "vue";
export const pool = ref<PositionPlaceholder[]>([]);

(window as any).motdPools = pool;

export function shouldRenderPlaceholder(
    poolValue: PositionPlaceholder[],
    pos: MotdPosition
) {
    if (poolValue.length == 0) return true; // render placeholder, so we can initialize positions
    const match = poolValue.find((x) => x.position == pos);
    if (match == null) return true; // position is not populated, so we have to render the component to initialize it
    return match.items.length;
}

export function getOrCreatePlaceholder(positionType: MotdPosition) {
    let item = pool.value.find((x) => x.position == positionType);
    if (item == null) {
        item = {
            items: [],
            position: positionType,
        };
        pool.value.push(item);
    }
    return item;
}
